import { Box, Container, Typography } from "@mui/material";
import React, { useContext } from "react";
import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { CombosContext } from "../../../context/combos/CombosContext";
import ProductCard from "../../../components/ProductCard/ProductCard";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { AuthContext } from "../../../context/authContext";
import logoDefault from "../../../images/productDefault.jpg";
import InventoryOutlinedIcon from "@mui/icons-material/InventoryOutlined";

export const Combos = () => {
  const { data }          = useContext(CombosContext);
  const { empresa = {} }  = useContext(AuthContext);

  const getImageSrc = (p) => {
    const a = p?.art_imagen?.trim();
    const e = empresa?.imagen_articulo?.trim();
    if (a) return `${process.env.REACT_APP_URL_BACKEND}${a}`;
    if (e) return `${process.env.REACT_APP_URL_BACKEND}${e}`;
    return logoDefault;
  };

  const products = (data?.combos || []).map((producto) => {
    const sf = producto?.stock != null
      ? producto.stock.toLocaleString("es-AR", { minimumFractionDigits: 0, maximumFractionDigits: 0, useGrouping: true })
      : "0";

    let textoPrecio;
    switch (producto?.tipoPrecioFinal) {
      case 2:  textoPrecio = "Oferta";     break;
      case 1:  textoPrecio = "Lista";      break;
      default: textoPrecio = "Disponible"; break;
    }

    const installment = producto?.stock > 0 ? `${textoPrecio}: ${sf} u` : "Sin Stock"
    ;

    const price    = producto?.precioMostrar != null
      ? "$" + producto.precioMostrar.toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      : "Precio no disponible";
    const priceOld = producto?.precioVigente != null
      ? "$" + producto.precioVigente.toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      : null;
    const percentage = producto?.precioVigente > 0 && producto?.precioMostrar != null
      ? (((producto.precioVigente - producto.precioMostrar) / producto.precioVigente) * 100)
          .toLocaleString("es-AR", { minimumFractionDigits: 0, maximumFractionDigits: 0 })
      : null;

    return {
      id: producto.id,
      code: producto.art_codigo,
      category: producto?.Ramo?.descripcion_ramo,
      description: producto.art_descripcion,
      section: "TrendingProducts",
      imgSrc: getImageSrc(producto),
      altText: producto.art_descripcion,
      title: producto.art_descripcion,
      price, precioMostrar: price, priceOld, percentage,
      stockActual: sf, installment,
      urls: [
        producto?.art_imagen?.trim()
          ? `${process.env.REACT_APP_URL_BACKEND}${producto.art_imagen}`
          : `${process.env.REACT_APP_URL_BACKEND}${empresa?.imagen_articulo}`,
      ],
    };
  });

  if (!products.length) return null;

  return (
    <Container maxWidth={false} sx={{ maxWidth: "var(--container-max)", px: { xs: 1.5, md: 3 }, py: { xs: 1.5, md: 2 } }}>

      {/* ── Header compacto ── */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, mb: { xs: 1.5, md: 2 } }}>
        <Box sx={{
          width: 34, height: 34, borderRadius: "9px",
          bgcolor: "rgba(59,130,246,0.08)",
          display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
        }}>
          <InventoryOutlinedIcon sx={{ color: "var(--info)", fontSize: 18 }} />
        </Box>
        <Box>
          <Typography sx={{
            fontFamily: "var(--font-heading)", fontWeight: 800,
            fontSize: { xs: "1.05rem", md: "1.2rem" },
            color: "var(--text-primary)", letterSpacing: "-0.02em", lineHeight: 1.1,
          }}>
            Combos
          </Typography>
          <Typography sx={{ fontFamily: "var(--font-body)", fontSize: "0.72rem", color: "var(--text-muted)" }}>
            Packs especiales con descuento
          </Typography>
        </Box>
      </Box>

      {/* ── Slider ── */}
      <Swiper
          navigation
          pagination={{ clickable: true }}
          breakpoints={{
            0:    { slidesPerView: 2,   spaceBetween: 8  },
            480:  { slidesPerView: 2.5, spaceBetween: 10 },
            640:  { slidesPerView: 3,   spaceBetween: 12 },
            900:  { slidesPerView: 4,   spaceBetween: 14 },
            1200: { slidesPerView: 5,   spaceBetween: 16 },
            1600: { slidesPerView: 6,   spaceBetween: 16 },
          }}
          modules={[Pagination, Navigation]}
          style={{ paddingBottom: "36px" }}
        >
          {products
            .filter(i => i.section === "TrendingProducts")
            .map(item => (
              <SwiperSlide key={item.id} style={{ height: "auto" }}>
                <ProductCard data={item} />
              </SwiperSlide>
            ))
          }
      </Swiper>

    </Container>
  );
};

export default Combos;